import * as React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { LogoIcon } from '../icons';
import type { LoadingBaseProps } from './loading.interface';

export const LoadingDefault: React.FC<LoadingBaseProps> = (
  props: LoadingBaseProps
) => {
  const theme = useTheme();
  const { title, subtitle, children } = props;

  return (
    <Box
      sx={[
        {
          fontWeight: 'bold',
          color: '#d6d6d6',
          backgroundRepeat: 'no-repeat',
          display: 'inline-flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          flex: 1,
          padding: theme.spacing(2, 0),
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <Box mb={1}>
        <LogoIcon sx={{ color: '#d6d6d6', fontSize: 60 }}></LogoIcon>
      </Box>
      {title && <Typography variant="h6">{title}</Typography>}
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
      {children}
    </Box>
  );
};

LoadingDefault.defaultProps = {
  title: 'loading...',
};
